
// ROUTES
require('modules/campaign-template/routes/campaign-template');

// CONTROLLERS
require('modules/campaign-template/controllers/campaign-template');
require('modules/campaign-template/controllers/list');
require('modules/campaign-template/controllers/create');
require('modules/campaign-template/controllers/edit');


// SERVICES
require('modules/campaign-template/services/campaign-template');
require('modules/campaign-template/services/list');
require('modules/campaign-template/services/create');
require('modules/campaign-template/services/edit');
require('modules/campaign-template/services/delete');
require('modules/campaign-template/services/preview');


angular.module('unica_campaign_template', [

	// ROUTES
	'unica_campaign_template.campaign_template_routes',

	// CONTROLLERS
	'unica_campaign_template.campaign_template_controllers',

	// SERVICES
	'unica_campaign_template.campaign_template_services'

]);